import { render, staticRenderFns } from "./EventSlider.vue?vue&type=template&id=aec14774&scoped=true"
import script from "./EventSlider.vue?vue&type=script&lang=js"
export * from "./EventSlider.vue?vue&type=script&lang=js"
import style0 from "./EventSlider.vue?vue&type=style&index=0&id=aec14774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec14774",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VCardTitle,VImg,VMenu})
